import { render, staticRenderFns } from "./RankingDetailView.vue?vue&type=template&id=d4fe089a&"
import script from "./RankingDetailView.vue?vue&type=script&lang=js&"
export * from "./RankingDetailView.vue?vue&type=script&lang=js&"
import style0 from "./RankingDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports